import { isEqual, upperFirst } from 'lodash'

import { billingsSources, proxy } from '@/utils'

import render from './render'

export default function(options) {
  return {
    name: options.path.split('.').map(upperFirst).join(''),

    mixins: [ proxy({ type: 'array' }) ],

    computed: {
      label() {
        return this.getTranslate(`${options.serviceName}.labels.${options.path}`)
      },

      disabled() {
        let result = false
        for (const item of this.proxy) {
          if (Object.values(item).some(value => {
            return value === undefined
          })) {
            result = true
          }
        }
        if (result) {
          return true
        }

        if (this.hasDuplicatedSources) {
          return true
        }

        if (isEqual(this.proxy, this.value)) {
          return true
        }

        return false
      },

      addDisabled() {
        const proxySources = this.proxy.map(item => {
          return item.source
        })
        const constantSources = Object.values(billingsSources)

        return proxySources.length >= constantSources.length
      },

      /**
       * Признак того, что источник операции встречается в строках более одного раза.
       * Контракт настройки хранит не более одной операции на каждый источник
       * @returns {boolean}
       */
      hasDuplicatedSources() {
        const proxySources = this.proxy.map(item => {
          return item.source
        })

        return proxySources.length !== new Set(proxySources).size
      }
    },

    methods: {
      /**
       * Приводит поля операций к типам контракта настройки referral.billings.processedChildOperations:
       * percent - число с плавающей точкой, limitMin и limitMax - целые числа
       * @param {Array<object>} value Значение proxy
       * @returns {Array<{ source: string, percent: number, limitMin: number, limitMax: number }>}
       */
      _outputFilter(value) {
        return value.map(item => {
          return {
            source: item.source,
            percent: parseFloat(item.percent) || 0,
            limitMin: parseInt(item.limitMin, 10) || 0,
            limitMax: parseInt(item.limitMax, 10) || 0
          }
        })
      },

      watchValueHandler() {
        return
      },
      watchProxyHandler() {
        return
      }
    },

    render(h) {
      return render.call(this, h, options)
    }
  }
}
